export const toReadable = (val: number | undefined, maximumFractionDigits = 0) => {
    if (!val) return 0;
    return val.toLocaleString('ru', { maximumFractionDigits });
  };